/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

// libraries
import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
    object, string,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import ReactHtmlParser from 'react-html-parser';
import { useUIDSeed } from 'react-uid';
import { ExpansionPanel, ExpansionPanelDetails, ExpansionPanelSummary } from '@material-ui/core';

import { clubComponentType } from '../common/types';

const styles = (theme) => ({
    panelRoot: {
        borderBottom: `2px solid ${theme.palette.cms?.black || '#2f2f2f'}`,
        borderTop: `2px solid ${theme.palette.cms?.black || '#2f2f2f'}`,
        boxShadow: 'inherit',
        '& .MuiExpansionPanelDetails-root': {
            display: 'block',
        },
        '& .MuiExpansionPanelSummary-root.Mui-expanded': {
            minHeight: '48px !important',
        },
    },
    summaryRoot: {
        display: 'block',
        '& .MuiExpansionPanelSummary-content': {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            margin: '0px',
        },

    },
    itemContentStyleMark: {
        display: 'block',
        '& p': {
            padding: '0px 20px',
        },
    },
    monthName: {
        fontSize: '1rem',
        lineHeight: '1.5rem',
        fontWeight: 700,
    },
    removeIcon: {
        '& path:first-child': {
            fill: theme.palette.headerColor || '#E8F1ED',
            opacity: 1,
        },
    },
    headerContent: {
        margin: '10px 0px',
    },
});

const GraphqlClubDescriptionV2 = ({
    longDescription,
    classes,
    clubComponents,
    shortDescription,
}) => {
    const seed = useUIDSeed();
    const [contentActive, setContentActive] = useState(true);
    const [descriptionAction, setDescriptionActive] = useState(false);
    const addIcon =  <img src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/blt137ba229a33bc496/63e9d22b167c064eec4b3f36/add_icon.svg?width=26&height=26&auto=webp`" alt="add button icon"  className={classes.iconImage} />;
    const removeIcon = <img src="https://images.contentstack.io/v3/assets/blt89dbf1c763ec00a6/bltce80760950cd82b9/63e9d22b0185c11a442d5fc4/remove_icon.svg?width=26&height=26&auto=webp`" alt="remove button icon" className={classes.iconImage} />;
    return (
        <>
            <div className={classes.contentContainer}>
                <ExpansionPanel classes={{ root: classes.panelRoot }} square expanded={contentActive}  onClick={() => setContentActive(!contentActive)}>
                    <ExpansionPanelSummary classes={{ root: classes.summaryRoot, content: classes.summaryContent }}>
                        <h2 className={classes.headerContent}>Contents</h2>
                        <span className={classes.icons} role="presentation">{(contentActive) ? removeIcon : addIcon}</span>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails classes={classes.detailsRoot} data-testId="description">
                        <ReactMarkdown source={shortDescription} escapeHtml={false} className={classes.itemContentStyleMark} />
                        {(clubComponents || []).map((component) => (
                            <p key={seed(component)}>
                                <span className={classes.monthName}>{ReactHtmlParser(component.month) || ''}</span>
                                <span>{ReactHtmlParser(component.longDescription) || ''}</span>
                            </p>
                        ))}
                    </ExpansionPanelDetails>
                </ExpansionPanel>
                {longDescription &&  (
                    <ExpansionPanel classes={{ root: classes.panelRoot }} square  expanded={descriptionAction} onClick={() => setDescriptionActive(!descriptionAction)}>
                        <ExpansionPanelSummary classes={{ root: classes.summaryRoot, content: classes.summaryContent }}>
                            <h2 className={classes.headerContent}>Description</h2>
                            <span className={classes.icons} role="presentation">{(descriptionAction) ? removeIcon : addIcon}</span>

                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails classes={classes.detailsRoot}>
                            <ReactMarkdown source={longDescription} escapeHtml={false} className={classes.itemContentStyleMark} />
                        </ExpansionPanelDetails>
                    </ExpansionPanel>
                )}
            </div>
        </>
    );
};

GraphqlClubDescriptionV2.propTypes = {
    classes: object.isRequired,
    longDescription: string,
    clubComponents: clubComponentType.isRequired,
    shortDescription: string,
};
GraphqlClubDescriptionV2.defaultProps = {
    longDescription: '',
    shortDescription: '',
};

export default (withStyles(styles)(GraphqlClubDescriptionV2));
